export function PaymentTermsNotice({ termsUrl, className = "" }: { termsUrl: string; className?: string }) {
    return <p className={"ah-payment-terms " + className}>By paying, you agree to the hire <a href={termsUrl} target="_blank" rel="noopener noreferrer">terms and conditions</a>.</p>
}
